<button
  class="white red"
  [class.indigo]="moduleItem?.TileID"
  [class.red]="!(moduleItem?.TileID)"
  (click)="openMenu()"
>
  @if (moduleItem?.TileID) {
    <i class="fa-solid fa-square-t"></i> {{moduleItem.TileID}}
  } @else {
    None Configured
  }

  @if (menuOpen) {
    <motn-popover-menu
      [optionGroup]="menuOptions"
      (clickedOutsideMenu$)="closeMenu()"
      (clickedOption$)="closeMenu()"
    ></motn-popover-menu>
  }

  @if (existingTilesMenuOpen) {
    <motn-popover-select-tiles
      [permittedFormat]="formatRestriction"
      [multiOrSingle]="'single'"
      [preselectedTileId]="$safeNavigationMigration(moduleItem?.TileID)"
      (clickedOption$)="onClickExistingTile($event)"
      (clickedOutsideMenu$)="onClickOutsideExistingTiles()"
    ></motn-popover-select-tiles>
  }
</button>

@if (label) {
  <div class="label">
    {{label}}

    @if (infoDialogContent) {
      <span (click)="infoDialogTile()">
        <i class="fa-regular fa-circle-info"></i>
      </span>
    }
  </div>
}

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="editingTile = null"
  ></motn-tile-editor>
}
